import axios from "axios";
import alert from "@/plugins/AlertMessages.js";
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

export default {
  getSocialNetworks({ dispatch, commit }, data) {
    axios
      .get("client/SocialNetwork?languageId=" + data)
      .then((res) => {
        commit("setSocialNetworks", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDate({ dispatch, commit }) {
    axios
      .get("client/Config/GetDate")
      .then((res) => {
        commit("setDate", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getLanguage({ dispatch, commit }) {
    axios
      .get("client/Language")
      .then((res) => {
        commit("setLanguage", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMenuPosition({ dispatch, commit }, data) {
    axios
      .get("client/Menu/LoadMenuPosition?languageId=" + data)
      .then((res) => {
        commit("setMenuPosition", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getHeaderMenu({ dispatch, commit }, data) {
    axios
      .get("client/Menu/LoadTree?menuPositionId=" + data)
      .then((res) => {
        commit("setHeaderMenu", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFooterMenu({ dispatch, commit }, data) {
    axios
      .get("client/Menu/LoadTree?menuPositionId=" + data)
      .then((res) => {
        commit("setFooterMenu", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getConfig({ dispatch, commit }, data) {
    axios
      .get("client/Config?languageId=" + data)
      .then((res) => {
        commit("setConfig", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAboutUs({ dispatch, commit }, { languageId, name }) {
    axios
      .get("client/Page/GetByName", {
        params: {
          languageId: languageId,
          name: name,
        },
      })
      .then((res) => {
        console.log("ABOUT US RESPONSE 👉", res.data.data);
        commit("setAboutUs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getLive({ dispatch, commit }, { languageId, name }) {
    axios
      .get("client/Page/GetByName", {
        params: {
          languageId: languageId,
          name: name,
        },
      })
      .then((res) => {
        commit("setLive", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getContactUs({ dispatch, commit }, data) {
    axios
      .get("client/Page/GetByName?languageId=" + data)
      .then((res) => {
        commit("setContactUs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addMessage({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("client/ContactUs", data.value, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept-Language": data.language,
        },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getCaptcha({ commit }) {
    axios
      .get("client/Captcha/CreateCaptchaParams", {
        withCredentials: true,
      })
      .then((res) => {
        commit("setCaptcha", res.data);
      })
      .catch(() => {
        commit("setError", alert.error.loadCaptcha, { root: true });
      });
  },

  getCategories({ dispatch, commit }, data) {
    axios
      .get("client/Category/LoadTree?groupId=" + data)
      .then((res) => {
        commit("getCategories", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // blog page
  getBlogs({ dispatch, commit }, data) {
    axios
      .get("client/Blog?" + data)
      .then((res) => {
        commit("setBlogs", res.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBlog({ dispatch, commit }, data) {
    axios
      .get("client/Blog/" + data)
      .then((res) => {
        commit("setBlog", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBlogComments({ dispatch, commit }, data) {
    axios
      .get("client/Blog/LoadComments/" + data)
      .then((res) => {
        commit("setComments", res.data.data);
        commit("setCommentsLength", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },

  sendCommentBlogs({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("client/Blog", data.value, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept-Language": data.language,
        },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.commentSent,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // media page
  getMedias({ dispatch, commit }, data) {
    axios
      .get("client/Media?" + data)
      .then((res) => {
        commit("setMedias", res.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMedia({ dispatch, commit }, data) {
    axios
      .get("client/Media/LoadAlbum/" + data)
      .then((res) => {
        commit("setMedia", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMediaGallery({ dispatch, commit }, data) {
    axios
      .get("client/Media/" + data)
      .then((res) => {
        commit("setMediaGallery", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMediaComments({ dispatch, commit }, data) {
    axios
      .get("client/Media/LoadComments/" + data)
      .then((res) => {
        commit("setMediaComments", res.data.data);
        commit("setMediaCommentsLength", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },

  sendCommentMedia({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("client/Media", data.value, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept-Language": data.language,
        },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.commentSent,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Photo page
  getPhotos({ dispatch, commit }, data) {
    axios
      .get("client/Photo?" + data)
      .then((res) => {
        commit("setPhotos", res.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPhoto({ dispatch, commit }, data) {
    axios
      .get("client/Photo/LoadAlbum/" + data)
      .then((res) => {
        commit("setPhoto", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPhotosGallery({ dispatch, commit }, data) {
    axios
      .get("client/Photo/" + data)
      .then((res) => {
        commit("setPhotosGallery", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPhotoComments({ dispatch, commit }, data) {
    axios
      .get("client/Photo/LoadComments/" + data)
      .then((res) => {
        commit("setPhotoComments", res.data.data);
        commit("setPhotoCommentsLength", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },

  sendCommentPhoto({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("client/Photo", data.value, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept-Language": data.language,
        },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.commentSent,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Book page
  getBooks({ dispatch, commit }, data) {
    axios
      .get("client/Book?" + data)
      .then((res) => {
        commit("setBooks", res.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBookGallery({ dispatch, commit }, data) {
    axios
      .get("client/Book/" + data)
      .then((res) => {
        commit("setBookGallery", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBookPublisher({ dispatch, commit }, data) {
    axios
      .get("client/Book?" + data)
      .then((res) => {
        commit("setBookPublisher", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBookComments({ dispatch, commit }, data) {
    axios
      .get("client/Book/LoadComments/" + data)
      .then((res) => {
        commit("setBookComments", res.data.data);
        commit("setBookCommentsLength", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },

  sendCommentBook({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("client/Book", data.value, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept-Language": data.language,
        },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.commentSent,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getBookContents({ dispatch, commit }, data) {
    axios
      .get("client/BookContent/LoadTree?bookId=" + data)
      .then((res) => {
        commit("setBookContents", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },

  getBookDetails({ dispatch, commit }, data) {
    axios
      .get("client/BookContent/" + data)
      .then((res) => {
        commit("setBookDetails", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },

  getPublishers({ dispatch, commit }, data) {
    axios
      .get("client/Book/LoadPublishers?languageId=" + data)
      .then((res) => {
        commit("setPublishers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAuthors({ dispatch, commit }, data) {
    axios
      .get("client/Book/LoadAuthors?languageId=" + data)
      .then((res) => {
        commit("setAuthors", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Sound page
  getSounds({ dispatch, commit }, data) {
    axios
      .get("client/Sound?" + data)
      .then((res) => {
        commit("setSounds", res.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSound({ dispatch, commit }, data) {
    axios
      .get("client/Sound/LoadAlbum/" + data)
      .then((res) => {
        commit("setSound", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSoundGallery({ dispatch, commit }, data) {
    axios
      .get("client/Sound/" + data)
      .then((res) => {
        commit("setSoundGallery", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSoundComments({ dispatch, commit }, data) {
    axios
      .get("client/Sound/LoadComments/" + data)
      .then((res) => {
        commit("setSoundComments", res.data.data);
        commit("setSoundCommentsLength", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },

  sendCommentSound({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("client/Sound", data.value, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept-Language": data.language,
        },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.commentSent,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Search page
  getSearch({ dispatch, commit }, data) {
    axios
      .get("client/Search?groupId=" + data)
      .then((res) => {
        commit("setSearch", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
};
